<p-table
  #dt
  responsiveLayout="scroll"
  [value]="data"
  [rowHover]="true"
  [columns]="cols"
  dataKey="id"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]"
  [paginator]="true"
  [globalFilterFields]="[
    'patient.name',
    'patient.apellidos',
    'pet.name',
    'pet.especie',
    'pet.raza',
    'pet.gender',
    'specialist.name'
  ]"
  exportFilename="visitas-{{ clinic.slug }}"
  [exportFunction]="exportFunction"
>
  <ng-template pTemplate="caption">
    <div class="flex justify-content-end flex-wrap align-items-center">
      <span class="p-input-icon-left mr-2">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          #filter
          (input)="onGlobalFilter(dt, $event)"
          placeholder="Buscar"
          class="w-full"
        />
      </span>
      <p-button icon="pi pi-download" label="Exportar" (onClick)="dt.exportCSV()" />
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="data.specialist.name" scope="col">
        Especialista <p-sortIcon field="data.specialist.name"></p-sortIcon>
      </th>
      <th pSortableColumn="data.patient.name" scope="col">
        Usuario <p-sortIcon field="data.patient.name"></p-sortIcon>
      </th>
      <th pSortableColumn="data.pet.especie" scope="col">
        Especie de Mascota <p-sortIcon field="data.pet.especie"></p-sortIcon>
      </th>
      <th pSortableColumn="data.pet.name" scope="col">
        Nombre de Mascota <p-sortIcon field="data.pet.name"></p-sortIcon>
      </th>
      <th pSortableColumn="data.pet.raza" scope="col">
        Raza de Mascota <p-sortIcon field="data.pet.raza"></p-sortIcon>
      </th>
      <th pSortableColumn="data.pet.gender" scope="col">
        Género de Mascota <p-sortIcon field="data.pet.gender"></p-sortIcon>
      </th>
      <th pSortableColumn="data.specialist.specialty" scope="col">
        Especialidad <p-sortIcon field="data.specialist.specialty"></p-sortIcon>
      </th>
      <th scope="col">Fecha</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.specialist.name }}</td>
      <td>{{ data.patient.name }} {{ data.patient.apellidos }}</td>
      <td>{{ data.pet.especie }}</td>
      <td>{{ data.pet.name }}</td>
      <td>{{ data.pet.raza }}</td>
      <td>{{ data.pet.gender }}</td>
      <td>{{ data.specialist.specialty }}</td>
      <td>{{ data.date | dateFormatVisit }}</td>
    </tr>
  </ng-template>
</p-table>
